import React, { useContext } from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { AppConfigContext } from '@providers/AppConfigProvider';

export default function EstateHelpContactCta() {
  const { pathRoot, comUrl } = useContext(AppConfigContext);
  return (
    <Box className="lg:max-w-[663px] lg:mx-auto mx-24 max-md:mx-5 mb-16 max-md:mb-8 lg:px-8 px-12 max-md:px-5 lg:py-10 py-16 max-md:py-8 bg-gray-01 rounded-3xl">
      <Link href={`${comUrl}estateHelpContact/`} className="text-rf-black no-underline group">
        <Box className="md:flex md:justify-between md:gap-x-4">
          <Box className="lg:w-[56%] md:w-[47%]">
            <Typography variant="h4" className="mb-7 max-md:mb-2 text-xl max-md:text-lg font-bold tracking-widest">
              物件探しにお困りの方へ
            </Typography>
            <Typography className="mb-7 max-md:mb-5 text-sm tracking-wider ">
              「理想の物件が見つからない」あなたに代わり、リノベのプロがお探しします。
            </Typography>
            <Box className="md:hidden max-md:mb-5">
              <img
                className="max-w-[300px] max-md:mx-auto w-[70%] object-cover"
                src={`${pathRoot}/assets/images/mansions/estate_contact.webp`}
                alt="物件探しにお困りの方へ"
              />
            </Box>
            <Box className="flex flex-col gap-y-2 max-md:mx-auto mb-9 mb-5 max-md:max-w-[300px]">
              <Typography className="text-sm font-bold tracking-wider relative pl-4 before:content-[''] before:absolute before:top-[6px] max-md:before:top-[7.2px] before:left-0 before:w-[6px] before:h-[6px] before:rounded-full before:bg-rf-red">
                探している条件の物件が見つからない
              </Typography>
              <Typography className="text-sm font-bold tracking-wider relative pl-4 before:content-[''] before:absolute before:top-[6px] max-md:before:top-[7.2px] before:left-0 before:w-[6px] before:h-[6px] before:rounded-full before:bg-rf-red">
                リノベーション向きの物件を教えてほしい
              </Typography>
              <Typography className="text-sm font-bold tracking-wider relative pl-4 before:content-[''] before:absolute before:top-[6px] max-md:before:top-[7.2px] before:left-0 before:w-[6px] before:h-[6px] before:rounded-full before:bg-rf-red">
                リノベーション済みの物件を探している
              </Typography>
            </Box>
            <Box className="max-md:flex max-md:justify-center">
              <Button color="primary" variant="contained" size="large" className="p-0 shadow-none">
                <Box className="rf-btn-black-md">物件探しを相談する</Box>
                <img
                  src={`${pathRoot}/assets/images/common/ArrowForwardRoundedIcon_white.svg`}
                  alt="arrow"
                  className="opacity-0  group-hover:opacity-100 absolute top-[19px] right-[20px] w-5 transition delay-150"
                />
              </Button>
            </Box>
          </Box>
          <Box className="max-md:hidden flex flex-col justify-center items-center lg:w-[44%] md:w-[53%]">
            <img
              className="w-full max-w-[300px] object-cover md:transition-transform md:duration-300 md:group-hover:scale-105"
              src={`${pathRoot}/assets/images/mansions/estate_contact.webp`}
              alt="物件探しにお困りの方へ"
            />
          </Box>
        </Box>
      </Link>
    </Box>
  );
}
